<template>
  <div class="video-block">
    <div class="video-container">
      <div v-if="!isVideoPlaying" class="flex-video-block">
        <img
          class="btn"
          src="@/assets/video/play-btn.png"
          alt="Video poster"
          @click="playVideo"
        />
        <img
          class="video"
          src="@/assets/video/video-bg.png"
          alt="Video poster"
          @click="playVideo"
        />
      </div>
      <video
        ref="videoPlayer"
        class="video"
        src="@/assets/video/video1.mp4"
        controls
        @play="onVideoPlay"
        v-show="isVideoPlaying"
      ></video>
      <span class="corner corner-top-left"></span>
      <span class="corner corner-top-right"></span>
      <span class="corner corner-bottom-left"></span>
      <span class="corner corner-bottom-right"></span>
    </div>
    <p class="desktop">{{ videoTitle }}</p>
    <p class="mobile">
      Формуємо технологічне військо, що наближає нашу Перемогу сьогодні та
      створює перспективу розвитку в майбутньому завдяки інноваційним
      технологіям і екосистемі долучення вмотивованих громадян
    </p>
  </div>
</template>

<script>
export default {
  name: "project-video-block",
  props: {
    videoTitle: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      isVideoPlaying: false,
    };
  },
  methods: {
    playVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.play();
        this.isVideoPlaying = true;
      }
    },
    onVideoPlay() {
      this.isVideoPlaying = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-block {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 699px;
  width: 100%;

  @media (max-width: 1360px) {
    max-width: unset;
  }

  .video {
    max-width: 650px;
    max-height: 413px;
    width: 100%;
    height: 100%;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;

    @media (max-width: 767px) {
      height: 205px;
    }
  }

  .video-container {
    position: relative;
    @media (max-width: 1360px) {
      order: 2;
      max-width: unset;
      border: 1px solid #1c1c1c;
    }
  }

  p {
    font-family: UAF Sans, serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;

    @media (max-width: 767px) {
      font-size: 18px;
    }

    &.desktop {
      @media (max-width: 767px) {
        display: none;
      }
    }

    &.mobile {
      @media (min-width: 768px) {
        display: none;
      }
    }

    @media (max-width: 1100px) {
      order: 1;
    }
  }
}

.corner {
  position: absolute;
  width: 10px;
  height: 10px;

  @media (max-width: 767px) {
    display: none;
  }
}

.corner-top-left {
  top: 0;
  left: 0;
  border-top: 2px solid black;
  border-left: 2px solid black;
}

.corner-top-right {
  top: 0;
  right: 0;
  border-top: 2px solid black;
  border-right: 2px solid black;
}

.corner-bottom-left {
  bottom: 0;
  left: 0;
  border-bottom: 2px solid black;
  border-left: 2px solid black;
}

.corner-bottom-right {
  bottom: 0;
  right: 0;
  border-bottom: 2px solid black;
  border-right: 2px solid black;
}

.flex-video-block {
  position: relative;

  .btn {
    position: absolute;
    max-width: 100px;
    top: calc(50% - 67px);
    left: calc(50% - 50px);
    @media (max-width: 767px) {
      max-width: 60px;
      top: calc(50% - 35px);
      left: calc(50% - 30px);
    }
  }
}
</style>
